<div class="">
    <h1 class="text-2xl font-bold mb-4"> {{ projectBudgetId ? 'Editar Presupuesto' : 'Crear Nuevo Presupuesto' }}</h1>
  
    <form [formGroup]="projectBudgetForm" (ngSubmit)="onSubmit()">
        
            <div class="shadow overflow-hidden border-b border-gray-200 rounded-lg">
              <table class="min-w-full divide-y divide-gray-200 bg-white">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Categoría <div appRequiredLabel></div>
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Subcategoría <div appRequiredLabel></div>
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Cantidad <div appRequiredLabel></div>
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Monto Presupuestado <div appRequiredLabel></div>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  
                    <tr>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <select id="budgetCategoryId" formControlName="budgetCategoryId"
                          (change)="onCategoryChange()"
                          class="w-full px-3 py-2 border border-neutral-300 rounded-md focus:ring focus:ring-blue-200">
                          <option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }} ({{ getBudgetTypeName(category.budgetType) }})
                          </option>
                        </select>
                        <div *ngIf="projectBudgetForm.get('budgetCategoryId')?.invalid && projectBudgetForm.get('budgetCategoryId')?.touched"
                          class="text-red-500 text-sm">
                          La categoría es obligatoria.
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <select id="budgetSubcategoryId" formControlName="budgetSubcategoryId"
                          (change)="loadProjectedAmount($event)"
                          class="w-full px-3 py-2 border border-neutral-300 rounded-md focus:ring focus:ring-blue-200">
                          <option *ngFor="let subcategory of getSubcategories(projectBudgetForm.get('budgetCategoryId')?.value)"
                            [value]="subcategory.id">
                            {{ subcategory.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="projectBudgetForm.get('budgetSubcategoryId')?.invalid && projectBudgetForm.get('budgetSubcategoryId')?.touched"
                          class="text-red-500 text-sm">
                          La subcategoría es obligatoria.
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <input type="number" id="qty" formControlName="qty"
                          class="w-full px-3 py-2 border border-neutral-300 rounded-md focus:ring focus:ring-blue-200" />
                        <div *ngIf="projectBudgetForm.get('qty')?.invalid && projectBudgetForm.get('qty')?.touched"
                          class="text-red-500 text-sm">
                          La cantidad debe ser al menos 1.
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <input type="text" appCurrencyFormatter id="projectedAmount" formControlName="projectedAmount"
                          class="w-full px-3 py-2 border border-neutral-300 rounded-md focus:ring focus:ring-blue-200" />
                        <div *ngIf="projectBudgetForm.get('projectedAmount')?.invalid && projectBudgetForm.get('projectedAmount')?.touched"
                          class="text-red-500 text-sm">
                          El monto debe ser 0 o mayor.
                        </div>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>

  
      <!-- BUTTONS AREA -->
  <div class="flex justify-between mt-4">
  
      <!-- Botón Crear Proyecto -->
      <button 
        type="submit" 
        class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md">
        {{ projectBudgetId ? 'Editar Presupuesto' : 'Crear Presupuesto' }}
      </button>
  </div>
  
  
    </form>
  </div>
  